export default [

     {
          path: '/online-admission',
          name: 'OnlineAdmission',
          component: () => import("@/views/Page/OnlineAdmission/OnlineAdmission.vue"),
          meta: {
               title: 'Online Admission',
          },
     },
     {
          path: '/online-admission/:id/specific-action',
          name: 'OnlineAdmissionSpecificAction',
          component: () => import("@/views/Page/OnlineAdmission/OnlineAdmissionSpecificAction.vue"),
          meta: {
               title: 'Specific Action',
          },
     },
];